export default __webpack_public_path__ + "static/media/check-circle.a660e91e.svg";